import { Box, FormHelperText } from "@mui/material"

import { FormikSwitch } from "../../../../../../shared/components/forms/Formik"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"

import { CompanyUserFormMode, CompanyUserFormValues } from "../companyUserFormTypes"

type CompanyUserSettingsPanelProps = Readonly<{
    mode: CompanyUserFormMode
}>

export function CompanyUserSettingsPanel({ mode }: CompanyUserSettingsPanelProps) {
    return (
        <>
            {mode === "update" && (
                <LocalizedStrict id="company-user-settings-active">
                    <FormikSwitch<CompanyUserFormValues> name="isActive">Active</FormikSwitch>
                </LocalizedStrict>
            )}

            <Box>
                <LocalizedStrict id="company-user-settings-send-invitation">
                    <FormikSwitch<CompanyUserFormValues> name="sendEmailInvitation">Send email invitation</FormikSwitch>
                </LocalizedStrict>
                <LocalizedStrict id="company-user-settings-send-invitation-helper">
                    <FormHelperText>The user receives a sign-in link by email.</FormHelperText>
                </LocalizedStrict>
            </Box>

            <Box>
                <LocalizedStrict id="company-user-settings-disable-sync">
                    <FormikSwitch<CompanyUserFormValues> name="disableUserSync">Disable user sync</FormikSwitch>
                </LocalizedStrict>
                <LocalizedStrict id="company-user-settings-disable-sync-helper">
                    <FormHelperText>When disabled, this user is ignored by the user-sync job.</FormHelperText>
                </LocalizedStrict>
            </Box>

            <Box>
                <LocalizedStrict id="company-user-settings-secretary">
                    <FormikSwitch<CompanyUserFormValues> name="isSecretary">Secretary</FormikSwitch>
                </LocalizedStrict>
                <LocalizedStrict id="company-user-settings-secretary-helper">
                    <FormHelperText>
                        Gets access to secretary tools for booking and managing orders on behalf of other users.
                    </FormHelperText>
                </LocalizedStrict>
            </Box>
        </>
    )
}
